import { userProfileService } from '../../user/services/profile';
import { middlewareService } from '../../shared/service';
import { utils } from "../../core/helpers/utils";

export const portfolioService = {
 getPortfolio,
 getSystematics,
 getTransactionHistory,
 getPortfolioGraph,
 getCompleteFundDetails,
 getUserFundDetails,
 getFundLevelSips,
 importPortfolio,
 generatePdf,
 fetchWalletData,
 fetchWallet,
 deleteTransaction,
 clearPdfDump,
 newGetSystematics,
};

function getPortfolio(pan) {
  var promises = [];

  promises.push(getPortfolioDetails(pan).catch(err => Object.assign({})));
  // promises.push(getPortfolioGraph(pan).catch(err => Object.assign({})));
  // promises.push(getSystematics(pan).catch(err => Object.assign({})));
  // promises.push(getTransactionHistory(pan).catch(err => Object.assign({})));

  return Promise
    .all(promises)
    .then(function(response) {
      return {
        portfolioDetails: response[0],
        portfolioGraph: response[1],
        activeSips: response[2],
        transactionHistory: response[3]
      };
    })
    .catch(function(error) {
      return Object.assign({});
    });

  // return userProfileService.getValidPans()
  //   .then(pansResponse => {
  //     var pan = pansResponse.default

      
  //   });
}

function getPortfolioDetails(pan) {
  const payload = {
    isAjax: true,
    pan: pan,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/getPortfolio', requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    });
}

function getPortfolioGraph(pan) {
  const payload = {
    isAjax: true,
    pan: pan,
    Platform : 'android',
    buildVersion: 49,
    source : 'iosApp'
  };

  return middlewareService.postApiData('/ios/getGraph', payload)
    .then(graphResponse => {
      return graphResponse;
    })
}

function getSystematics(pan) {
  const payload = {
    isAjax : true,
    pan: pan,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/portfolio/ios/getSystematics?pan='+pan, requestOptions)
    .then(response => response.json())
    .then(result => {
      const activeSips = utils.parsePayload(result);
      
      if(activeSips && activeSips.systematics) {
        return activeSips.systematics;
      } else {
        return [];
      }
    })
    .catch(error => {
      return [];
    });
}

function getTransactionHistory(pan, email, hasBse) {
  const payload = {
    isAjax: true,
    source: 'iosApp',
    Platform: 'web',
    pan: pan,
    email: email,
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  let url   =  hasBse ? "/txHistory/v2/timelineNew": "/txHistory/timelineNew"
  return fetch(process.env.REACT_APP_API_URL + url, requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    });
}

function getCompleteFundDetails(fundId) {
  var payload = {
    amfi: fundId,
    isAjax : true,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/getFundDetails', requestOptions)
    .then(response => response.json())
}

function getUserFundDetails(fundId, pan) {
  var payload = {
    amfi: fundId,
    pan: pan || '',
    isAjax : true,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/getUserFundDetails', requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    });
}

function getFundLevelSips(fundId, pan) {
  var payload = {
    codeAMFI: fundId,
    isAjax : true,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/portfolio/ios/getSystematics?pan='+pan, requestOptions)
    .then(response => response.json())
    .then(result => {
      const sips = utils.parsePayload(result);
      return sips.systematics;
    })
    .catch(error => {
      return [];
    });
}

function importPortfolio(file, password) {

  var data = new FormData();
      data.append('userdetailedcas', file);
      data.append('password', password);
      data.append('Platform', 'web');
      data.append('source', 'iosApp');

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    body: data,
    headers: {
      "use-pkey" : false
    }
  };

  return fetch(process.env.REACT_APP_API_URL + '/ios/uploadPdf?isAjax=true', requestOptions)
    .then(response => {
      // return response.json();
      return response.text();
    })
    .then(text => {
      // This is a weird endpoint...returns blank response if everything is valid and a json response if there is an error. 
      // Hence we try to parse as text, and figure from there.
      try {
          const data = JSON.parse(text);
          // This means there is a possible error.
          return data;
      } catch(err) {
         // this means response was blank...so definitely successful upload.
         return {
          success: true
         };
      }
    })
    // .then(json => {
    //   console.log(json);
    //   return json;
    // })
    .catch(err => {
      return err;
    });
}

function generatePdf(email) { /**Unused function */
  var payload = {
    email: email,
    isAjax : true,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    }
  };

  return fetch(process.env.REACT_APP_API_URL + '/portfolio/generatePdf', requestOptions)
    .then(response => response.json())
    .catch(err => {
      return err;
    });
}

function fetchWalletData(){
  let promises = [];
  promises.push(fetchWallet());
  promises.push(fetchWalletHistory());

  return Promise
    .all(promises)
    .then(function(response) {
      return {
        wallet: response[0],
        walletHistory: response[1]
      };
    })
    .catch(function(error) {
      console.log(error);
      return Object.assign({});
    });
}
function fetchWalletHistory() {
  const requestOptions = {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    }
  };

  return fetch(process.env.REACT_APP_API_URL + '/wallet/cartFeesLogs', requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    })
    .catch(function(error) {
      console.log(error);
      return Object.assign({});
    });;
}

function fetchWallet() {
  var payload = {
    isAjax : true,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/wallet', requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    })
    .catch(err => {
      return err;
    });
}

function deleteTransaction(_url, row) {
  // var payload = {
  //   isAjax : true
  // };
  let payload = row;
  payload['isAjax'] = true;
  payload['Platform'] = 'web';
  payload['source'] = 'iosApp';

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(payload),
    headers: new Headers({
      'Content-Type': 'application/json',
      "use-pkey" : false
    }),
  };

  return fetch(process.env.REACT_APP_API_URL + _url, requestOptions)
    .then(response => response.json())
    .then(result => {
      return utils.parsePayload(result);
    })
    .catch(err => {
      return err;
    });
}

function clearPdfDump() {
  let  url = "/portfolio/clearPdfDump"
  return middlewareService.getApiData(url)
  .then(resp => {
    return utils.parsePayload(resp);
  })
  .catch(_ => {
    return {success: false};
  });
}

function newGetSystematics (email) {
  const payload = {
    isAjax : true,
    email: email,
    Platform : 'web',
    source : 'iosApp'
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      "use-pkey" : false
    },
    credentials: 'include',
    body: JSON.stringify(payload)
  };

  return fetch(process.env.REACT_APP_API_URL + '/portfolio/v2/ios/getSystematics', requestOptions)
    .then(response => response.json())
    .then(result => {
      const activeSips = utils.parsePayload(result);

      if(activeSips && activeSips.systematics) {
        return activeSips.systematics;
      } else {
        return [];
      }
    })
    .catch(error => {
      return [];
    });
}